import "./modules/common";
import VueApp from "~/Scripts/new/vueApp";

new VueApp( {
  name: "marketingThemeArea"
} );
